import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { CommerrorService } from "./commerror.service";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: "root",
})
export class InterceptorService implements HttpInterceptor {
  constructor(private ce: CommerrorService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authReq = req.clone({
      setHeaders: {
        "X-App-Version": environment.appVersion,
      },
    });
    return next.handle(authReq).pipe(
      tap(
        (data) => {
          this.ce.resetErr();
        },
        (error) => {
          this.ce.handleCommError(error);
        }
      ) //,
      //catchError(this.handleError),
    );
  }
}
